<template>
  <v-container class="my-5">
    <v-row justify="center" class="black--text">
      <v-col cols="12" md="12" v-if="false">
        <div class="d-flex">
          <div class="d-inline">
            <v-btn
              class="mr-2 mb-2"
              fab
              depressed
              dark
              x-small
              :to="{ name: 'News' }">
              <v-icon dark>
                mdi-arrow-left-thick
              </v-icon>
            </v-btn>
            <span class="title">Back to news list</span>
          </div>
          <v-spacer></v-spacer>
          <div class="d-inline" v-if="!loading.detail && detaildata.length > 0">
            <ShareNetwork
              network="facebook"
              :url="getRouteUrl('NewsDetail', { berita: detaildata[0].id_berita })"
              :title="detaildata[0].judul_berita"
              :description="detaildata[0].prev_berita"
              :quote="detaildata[0].prev_berita"
              hashtags="careercenter,pnb,bali"
              class="text-decoration-none mr-1">
              <v-icon large color="indigo">
                mdi-facebook
              </v-icon>
            </ShareNetwork>
            <ShareNetwork
              network="whatsapp"
              :url="getRouteUrl('NewsDetail', { berita: detaildata[0].id_berita })"
              :title="detaildata[0].judul_berita"
              :description="detaildata[0].prev_berita"
              :quote="detaildata[0].prev_berita"
              hashtags="careercenter,pnb,bali"
              class="text-decoration-none">
              <v-icon large color="green">
                mdi-whatsapp
              </v-icon>
            </ShareNetwork>
          </div>
        </div>
      </v-col>
      <v-col cols="12" md="8">
        <v-card
          flat>
          <v-card-text class="black--text">
            <div v-if="alertdata.show">
              <alertsp :alertdata="alertdata" class="mb-0"></alertsp>
            </div>
            <div v-if="loading.detail" class="text-center">
              <v-progress-circular
                :width="3"
                color="red"
                indeterminate>
              </v-progress-circular>
            </div>
            <div
              class="black--text"
              v-if="!loading.detail && detaildata.length > 0">
              <h1 class="text-md-h5 font-weight-bold mb-3 line-h-normal">
                {{ detaildata[0].judul_berita ? detaildata[0].judul_berita : 'News Title' }}
              </h1>
              <div class="d-flex">
                <v-chip
                  class="mr-1"
                  color="deep-orange"
                  small
                  dark
                  :title="detaildata[0].tgl_berita">
                  <v-icon left small>
                    mdi-update
                  </v-icon>
                  <timeago :datetime="detaildata[0].tgl_berita"></timeago>
                </v-chip>
                <v-chip
                  class="mr-1"
                  color="success"
                  small
                  dark>
                  <v-icon left small>
                    mdi-alpha-t-circle
                  </v-icon>
                  {{ detaildata[0].type_berita }}
                </v-chip>
                <v-chip
                  class="mr-1"
                  color="primary"
                  small
                  dark>
                  <v-icon left small>
                    mdi-alpha-c-circle
                  </v-icon>
                  {{ detaildata[0].cat_berita }}
                </v-chip>
                <v-spacer></v-spacer>
                <ShareNetwork
                  network="facebook"
                  :url="getRouteUrl('NewsDetail', { berita: detaildata[0].id_berita })"
                  :title="detaildata[0].judul_berita"
                  :description="detaildata[0].prev_berita"
                  :quote="detaildata[0].prev_berita"
                  hashtags="international,pnb,bali"
                  class="text-decoration-none d-inline mr-1">
                  <v-icon color="indigo">
                    mdi-facebook
                  </v-icon>
                </ShareNetwork>
                <ShareNetwork
                  network="whatsapp"
                  :url="getRouteUrl('NewsDetail', { berita: detaildata[0].id_berita })"
                  :title="detaildata[0].judul_berita"
                  :description="detaildata[0].prev_berita"
                  :quote="detaildata[0].prev_berita"
                  hashtags="international,pnb,bali"
                  class="text-decoration-none d-inline mr-1">
                  <v-icon color="green">
                    mdi-whatsapp
                  </v-icon>
                </ShareNetwork>
              </div>
              <v-divider class="my-5"></v-divider>
              <div v-if="detaildata[0].pic_berita" class="mb-5">
                <v-img
                  :lazy-src="require('../assets/default.jpg')"
                  :src="api + '/upload/news/' + detaildata[0].pic_berita">
                </v-img>
              </div>
              <div class="content-editor">
                <div
                  class="text--primary ql-editor"
                  v-html="detaildata[0].isi_berita">
                </div>
              </div>
              <div class="d-flex mt-5">
                <div class="d-inline">
                  <v-btn
                    class="mr-2 mb-2"
                    fab
                    depressed
                    dark
                    x-small
                    :to="{ name: 'News' }">
                    <v-icon dark>
                      mdi-arrow-left-thick
                    </v-icon>
                  </v-btn>
                  <span class="title" v-if="$i18n.locale === 'id'">Kembali ke list berita</span>
                  <span class="title" v-if="$i18n.locale === 'en'">Back to news list</span>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card flat>
          <v-card-text class="black--text">
            <h2 class="text-md-h5 font-weight-bold mb-3 line-h-normal">
              {{ $t('title.relatedinfo') }}
            </h2>
            <v-divider class="my-2"></v-divider>
            <v-row>
              <v-col cols="12" md="12">
                <router-link
                  v-for="(cat, i) in catlist"
                  :key="i"
                  class="link-list-style text-decoration-none"
                  :to="{ name: 'NewsDetail', query: { berita: cat.id_berita } }">
                  <div>
                    <v-icon small class="mb-1 mr-1">
                      mdi-update
                    </v-icon>
                    <timeago :datetime="cat.tgl_berita"></timeago>
                  </div>
                  <div class="d-flex item-list-style py-2">
                    <div class="d-inline mr-3">
                      <v-img
                        max-height="80"
                        max-width="80"
                        :src="cat.urlpic ? cat.urlpic : ''">
                      </v-img>
                    </div>
                    <div class="d-inline">
                      <div class="line-h-normal">
                        {{ cat.judul_berita }}
                      </div>
                    </div>
                  </div>
                </router-link>
                <div v-if="catlist.length <= 0" class="grey--text">
                  not available!
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Check',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      detail: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    baseurl: process.env.VUE_APP_BASEURL,
    publickey: '123',
    detaildata: [],
    catlist: [],
    panduan: null,
    paramberita: {
      search: '',
      limit: '',
      offset: '',
    },
    paramcategory: {
      search: '',
      limit: '',
      offset: '',
      lang: '',
      type: '',
      category: '',
      notin: '',
    },
    check: {
      berita: '',
    },
    formcheck: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
  }),
  watch: {
    '$route.query.berita'(val) {
      if (val) {
        this.check.berita = val;
        this.getBerita();
      }
    },
  },
  mounted() {
    if (this.$route.query.berita && this.$route.query.berita !== '') {
      this.check.berita = this.$route.query.berita;
      this.getBerita();
    }
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
    ]),
  },
  methods: {
    getRouteUrl(nameroute, paramroute) {
      const props = this.$router.resolve({
        name: nameroute,
        query: paramroute,
      });
      return this.baseurl + '' + props.href;
    },
    getBerita() {
      this.loading.detail = true;
      this.alertdata.show = false;
      this.detaildata = [];
      if (this.check.berita) {
        this.axios
          .get(
            this.api + '/public/berita/' + this.check.berita,
            {
              params: this.paramberita,
              headers: {
                Authorization: 'bearer ' + this.publickey,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.detaildata = resdata.data;
                this.getBycategory();
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.detail = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.detail = false;
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
          });
      } else {
        this.loading.detail = false;
        this.alertdata.show = true;
        this.alertdata.type = 'error';
        this.alertdata.text = 'Berita tidak ditemukan!';
      }
    },
    getBycategory() {
      this.catlist = [];
      this.paramcategory.lang = this.$i18n.locale;
      this.paramcategory.limit = 10;
      this.paramcategory.type = this.detaildata[0].type_berita;
      this.paramcategory.category = this.detaildata[0].cat_berita;
      this.paramcategory.notin = this.detaildata[0].id_berita;
      this.axios
        .get(
          this.api + '/public/berita',
          {
            params: this.paramcategory,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              resdata.data.forEach((element) => {
                if (element.pic_berita) {
                  element.urlpic = this.api + '/upload/news/' + element.pic_berita;
                } else {
                  element.urlpic = require('../assets/default.jpg');
                }
                this.catlist.push(element);
              });
              // console.log(this.catlist);
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
